import './RssFeedModal.scss';

import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { api } from '../../../utils/api';

function createInitialFormDataState(rssFeed = null) {
  return {
    title:        rssFeed?.title        || "",
    url:          rssFeed?.url          || "",
    original_url: rssFeed?.original_url || "",
    location:     rssFeed?.location     || "",
    latitude:     rssFeed?.latitude     || "",
    longitude:    rssFeed?.longitude    || "",
    distance:     rssFeed?.distance     || "",
  };
}

export default function RssFeedModal({ show, handleClose, rssFeed, rssFeeds, setRssFeeds }) {
  const [formData, setFormData] = useState(createInitialFormDataState());

  // Load rssFeed into form when editing
  useEffect(() => {
    setFormData(createInitialFormDataState(rssFeed));
  }, [rssFeed]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const payload = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== "" && value !== undefined) {
        payload[key] = value;
      } else {
        payload[key] = null;
      }
    });

    if (rssFeed && rssFeed.id) {
      setRssFeeds(prevRssFeeds =>
        prevRssFeeds.map(r => (r.id === rssFeed.id ? { ...r, ...payload } : r))
      );
      api.put(`/rss_feeds/${rssFeed.id}`, payload);
    } else {
      const { data: newRssFeed } = await api.post(`/rss_feeds`, payload);
      setRssFeeds(prevRssFeeds => [newRssFeed, ...prevRssFeeds]);
    }

    handleClose();
  };

  const handleDelete = async () => {
    // setJobs(prevJobs => prevJobs.filter(j => j.id !== job.id));
    // api.delete(`/job_postings/${job.id}`);
    handleClose();
  };

  return (
    <Modal className="__job-posting-modal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{rssFeed ? "Edit RSS Feed" : "Create RSS Feed"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter RSS Feed title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>URL</Form.Label>
            <Form.Control
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="Enter url"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Craigslist URL</Form.Label>
            <Form.Control
              name="original_url"
              value={formData.original_url}
              onChange={handleChange}
              placeholder="Enter url"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Location</Form.Label>
            <Form.Control
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter location"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Latitude</Form.Label>
            <Form.Control
              name="latitude"
              value={formData.latitude}
              onChange={handleChange}
              placeholder="Enter latitude"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Longitude</Form.Label>
            <Form.Control
              name="longitude"
              value={formData.longitude}
              onChange={handleChange}
              placeholder="Enter longitude"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Distance</Form.Label>
            <Form.Control
              name="distance"
              value={formData.distance}
              onChange={handleChange}
              placeholder="Enter distance"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        {rssFeed && false &&
          <Button className="ppy-btn ppy-btn-secondary" onClick={handleDelete}>
            Delete
          </Button>
        }
        <Button className="ppy-btn ppy-btn-tertiary" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="ppy-btn ppy-btn-primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}